<div #container class="turnstile-container"></div>
@if (hasError()) {
  <p class="turnstile-error" role="alert">
    No se ha podido cargar la verificación. Revisa tu conexión e inténtalo de nuevo.
  </p>
}
